<script setup>
const openLineChat = () => {
    window.open('https://lin.ee/X50R3qg', '_blank')
}
</script>

<template>
    <div class="line-icon-container" @click="openLineChat">
        <div class="line-icon">
            LINE
        </div>
    </div>
</template>

<style scoped>
.line-icon-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.line-icon-container:hover {
    transform: scale(1.1);
}

.line-icon {
    background-color: #00B900;
    color: white;
    font-weight: 700;
    font-size: 16px;
    padding: 12px 20px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 185, 0, 0.4);
    animation: bounce 2s infinite;
}

@keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
    }
    40% {
        transform: translateY(-10px);
    }
    60% {
        transform: translateY(-5px);
    }
}

@media (max-width: 768px) {
    .line-icon-container {
        display: none;
    }
}
</style>